import React from "react"
import Paper from "@material-ui/core/Paper";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { UserState } from "../../store/user/types";
import Home from '../home/Home';
import {connect} from "react-redux";
import {AppState} from "../../store";
import {thunkSaveSupplierId} from "../../store/thunks";
import axios from "axios";

interface IProps {
    t: any;
    user: UserState;
    thunkSaveSupplierId: any;
}

interface IState {
    supplierNo: string;
    //user: UserState;
}

class Viewer extends React.Component <IProps, IState> {

    state = {
        user : this.props.user,
        supplierNo :''
    }

    componentDidMount(): void {
        document.title = this.props.t('viewer.doctitle')
    }

    handleChange = (event : React.ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        if (value != null) {
            this.setState({supplierNo: value});
        }
    }

    handleSave = (event : any) => {
        event.preventDefault();
        this.props.thunkSaveSupplierId(this.state.supplierNo);
    };

    handleEnter = (event : React.KeyboardEvent) =>{
        if(event.keyCode == 13){
            this.handleSave(event);
        }
    }

    handleExport = () => {
        this.showDocument();
    }

    showDocument = async () => {
        const doc = await this.getDocumentUrl();

        if (doc.headers.location) {
            try {
                window.location = doc.headers.location;
            } catch(error) {
                console.error('error open file ' + error)
            }
        }
    }

    getDocumentUrl = async () => {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/suppliers/' + this.state.user.supplierId + '/export/eutrdeclarations' || '';
        return await axios.post (url);
    };

     render() {
        const { t } = this.props;
        if(this.props.user.isLoggedIn) {
            return (
                <Paper style={{padding: "10px", margin: "25px"}}>
                    <form onKeyDown={this.handleEnter}>
                            <InputLabel> <strong>{t('viewer.supplierNo')}</strong> </InputLabel>
                            <Input name="supplierNo" type="text" defaultValue={this.state.user.supplierId} onChange={this.handleChange}/>
                            <Button onClick={this.handleSave} variant="contained" color="primary" style={{marginLeft: '20px'}}>
                                {this.props.t('viewer.save')}
                            </Button>
                            <Button onClick={this.handleExport} variant="contained" color="primary" style={{marginLeft: '20px'}} disabled={this.state.user.supplierId == null} >
                                {this.props.t('viewer.export')}
                            </Button>
                    </form>
                </Paper>
            )
        } else  {
            return(
                <Home/>
            )
        }
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {thunkSaveSupplierId})(Viewer);
